import type { ClientDatabase } from '@app/icare/client/db/schema'
import type { AppRouter } from '@app/icare/router'
import type { ClientStatusTabStateType } from '@app/icare/server/db/schema/ClientStatus'
import { sstStage } from '@pkg/shared/env'
import { logger } from '@pkg/shared/logger'
import type { SyncRuntime } from '@pkg/sync/client'
import type { Kysely } from 'kysely'

type AppSync = SyncRuntime<ClientDatabase, ClientStatusTabStateType>

type AppDevTools = {
  database: Kysely<ClientDatabase>
  navigate: AppRouter['navigate']
  ready: Promise<void>
  sync: AppSync
}

declare global {
  interface Window {
    __appDatabase?: Kysely<ClientDatabase>
    __appNavigate?: AppRouter['navigate']
    __appReady?: Promise<void>
    __appSync?: AppSync
  }

  var __appDatabase: Kysely<ClientDatabase> | undefined
  var __appNavigate: AppRouter['navigate'] | undefined
  var __appReady: Promise<void> | undefined
  var __appSync: AppSync | undefined
}

export const installDevTools = ({ database, navigate, ready, sync }: AppDevTools) => {
  if (sstStage === 'prod') return

  globalThis.__appDatabase = database
  globalThis.__appNavigate = navigate
  globalThis.__appReady = ready
  globalThis.__appSync = sync
  logger.info({ tools: ['database', 'navigate', 'ready', 'sync'] }, 'Installed app dev tools')
}
